import { openingTimeTableUrl } from "../resources";
import putRequest from '../common/putRequest.js';

async function updateOpeningTime(restaurantid, label, data, token) {
    data.restaurantId = restaurantid;
    let url = `${openingTimeTableUrl}/${restaurantid}/${label}`;
    await putRequest.putDataWithToken(url, data, token);
}

export default {
    updateOpeningTime
}